import { isCancel, CancelToken } from 'axios';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { ReactSelectAsyncInput } from '@hivebrite/design-system/Inputs';

import { useApi } from 'hb-builder/api';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

const LABEL = {
  events: 'title',
  news: 'subject',
};

const ManualItemsSelector = ({
  idSettingKey,
  item,
  itemSettingKey,
  onChange,
  type,
}) => {
  const {
    authenticationIds: { admin, network, topic },
    getUrl,
  } = useApi();
  const [defaultValue, setDefaultValue] = useState(null);
  const selectedItem = item?.attributes?.dynamicAttributes?._selectedItem;

  useEffect(() => {
    if (selectedItem?.value) {
      setDefaultValue(selectedItem);

      return;
    }

    setDefaultValue(null);
  }, [selectedItem]);

  const handleChange = (option) => {
    setDefaultValue(option);

    onChange({
      id: item.id,
      values: [
        {
          settingKey: idSettingKey,
          value: option?.value || null,
        },
        {
          settingKey: itemSettingKey,
          value: option,
        },
      ],
    });
  };

  const makeFetchTerm = ({ url, query, delay = 500 }) => {
    let cancelToken = null;

    if (!url) {
      return null;
    }

    return debounce((inputValue, callback) => {
      // Cancel current request if we do another request
      if (cancelToken) {
        cancelToken.cancel();
      }

      cancelToken = CancelToken.source('Request canceled');

      if (!inputValue) {
        return callback([]);
      }

      axios
        .post(url, {
          admin_id: admin,
          cancelToken: cancelToken.token,
          network_id: network,
          query,
          term: inputValue,
          topic_id: topic,
        })
        .then(({ data }) =>
          callback(
            data[type].map((d) => {
              const label = LABEL[type];

              return {
                label: d[label],
                value: d.id,
              };
            }),
          ),
        )
        .catch((err) => {
          if (isCancel(err)) {
            return err.message;
          }

          return err;
        });
    }, delay);
  };

  return (
    <Box flexDirection="column" mb={4}>
      <InputTitle
        boxProps={{ mb: 2 }}
        id="settingsSelect"
        label={s__('Builder|Choose %{type}').i__({
          type,
        })}
      />
      <ReactSelectAsyncInput
        clearable
        id="manual-item-id"
        name="manual-item-id"
        placeholder={s__('Builder|Search by title')}
        onChange={handleChange}
        value={defaultValue}
        isSearchable
        noOptionsMessage={({ inputValue }) =>
          inputValue
            ? __('%{type} %{search} not found').i__({
                search: inputValue,
                type: type.charAt(0).toUpperCase() + type.slice(1),
              })
            : __('Search for a %{type}').i__({
                type: type.charAt(0).toUpperCase() + type.slice(1),
              })
        }
        // @TODO use new query
        loadOptions={makeFetchTerm({
          url: getUrl({
            apiSettings: {
              appContext: 'backoffice',
              routeSelector: type,
            },
            type: 'fetchData',
          }),
          query: {
            type: 'last_published',
          },
        })}
      />
    </Box>
  );
};

export default ManualItemsSelector;
